import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_PROJECT_ID, // This is your project ID
  storageBucket: process.env.NEXT_PUBLIC_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const dbName =
  process.env.NEXT_PUBLIC_CONNECTED_DB === "production"
    ? "default"
    : "oct-back-up-test-db"; // Replace "default" with your default DB name if it's named otherwise
const db =
  dbName === "default"
    ? getFirestore(app) // Use default Firestore
    : initializeFirestore(app, {}, dbName); // Initialize a specific Firestore DB

const storage = getStorage(app);
const projectId = app.options.projectId;

export { auth, provider, db, app, storage, dbName };
